var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9993 24.5039H4.99935C4.26297 24.5039 3.66602 25.1009 3.66602 25.8372V27.1706C3.66602 27.907 4.26297 28.5039 4.99935 28.5039H26.9993C27.7357 28.5039 28.3327 27.907 28.3327 27.1706V25.8372C28.3327 25.1009 27.7357 24.5039 26.9993 24.5039Z",
    stroke: "#4B4949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 13.1676V24.5143M24.9993 13.1676V24.5143M19.3327 13.1676V24.5143M12.666 13.1676V24.5143M14.7193 4.20228L4.35935 9.86895C4.14953 9.98376 3.97445 10.1529 3.85246 10.3586C3.73048 10.5643 3.66608 10.7991 3.66602 11.0383V12.3676C3.66602 12.5798 3.7503 12.7833 3.90033 12.9333C4.05036 13.0833 4.25384 13.1676 4.46602 13.1676H27.5327C27.7449 13.1676 27.9483 13.0833 28.0984 12.9333C28.2484 12.7833 28.3327 12.5798 28.3327 12.3676V11.0383C28.3326 10.7991 28.2682 10.5643 28.1462 10.3586C28.0242 10.1529 27.8492 9.98376 27.6393 9.86895L17.2793 4.20228C16.8869 3.98755 16.4467 3.875 15.9993 3.875C15.552 3.875 15.1118 3.98755 14.7193 4.20228Z",
    stroke: "#4B4949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.1fa377683a91eaaa15417bd98a458c8d.svg";
export { ForwardRef as ReactComponent };